module.exports = __webpack_public_path__ + "img/城图bg@2x.6bd0915b.png";